import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(({variables, breakpoints, palette}) => ({
  notificationsListDrawer: {
    position: 'fixed',
    top: '56px',
    right: 0,
    width: '360px',
    zIndex: 3,
    margin: 0,
    padding: 0,
    listStyle: 'none',
    paddingTop:variables?.spacingD,
    flex: '1 1 auto',
    [breakpoints.down('sm')]: {
      top:'unset',
      bottom:  `calc(${variables?.spacingG} - ${variables?.spacingD})`,
      width:`calc(100% - ${variables?.spacingF})`,
      marginLeft:variables?.spacingD,
      marginRight:variables?.spacingD,
    },
    '&.notificationDrawerOpen': {
      width: 'auto',
      position:'relative',
      top:0,
      marginLeft:0,
      marginRight:0,
    },

  },
  notificationsList: {
    position: 'fixed',
    top: '56px',
    right: variables?.spacingD,
    width: '360px',
    zIndex: 3, // was 7 before
    margin: 0,
    padding: 0,
    listStyle: 'none',
    paddingTop:variables?.spacingD,
    flex: '1 1 auto',
    [breakpoints.down('sm')]: {
      top:'unset',
      bottom:  `calc(${variables?.spacingG} - ${variables?.spacingD})`,
      width:`calc(100% - ${variables?.spacingF})`,
      marginLeft:variables?.spacingD,
      marginRight:variables?.spacingD,
    },
    '&.notificationDrawerOpen': {
      width: 'auto',
      position:'relative',
      top:0,
      marginLeft:0,
      marginRight:0,
    },

  },
  emptyNotificationMessage: {
    position:'absolute',
    top:'50%',
    left:'50%',
    transform: 'translate(-50%, -50%)',
    textAlign: 'center',
    width:'100%',
  },
  newNotification:{
    backgroundColor:palette.jet?.containerStrong
  },
  notificationWrapper:{
    padding: variables?.spacingD,
  },
  showMoreButton:{
    color:palette.jet?.supportInfo,
    textDecoration:'underline',
    cursor:'pointer',
    marginTop: variables?.spacingG,
    marginBottom: variables?.spacingG,
    marginLeft:'auto',
    marginRight:'auto'
  }
}));

export default useStyles;
